import React from "react";
import "./ResearchArea.scss";
import {areasSection} from "../../portfolio";

export default function ResearchArea() {
  return (
    <div>
      <div className="research-areas-main-div">
        <ul className="dev-icons">
          {areasSection.researchAreas.map((areas, i) => {
            return (
              <li
                key={i}
                className="research-area-inline"
                name={areas.areaName}
              >
                <i className={areas.fontAwesomeClassname}></i>
                <p>{areas.areaName}</p>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
